<template>
    <div v-if="balise.id" class="card shadow my-3 bg-white rounded vehicle-map-card">
        <div class="vehicle-map-preview">
            <l-map v-if="coordinates" :key="coordinates.join(',')" class="vehicle-map-preview__leaflet"
                :center="coordinates" :zoom="16" :min-zoom="3" :max-zoom="19" :options="mapOptions"
                :attribution-control="false">
                <l-tile-layer :url="tileLayerUrl" :max-zoom="19" />
            </l-map>

            <img v-if="coordinates && balise.icon" class="vehicle-map-preview__icon"
                :src="`/img/cars/${balise.icon}`" :alt="`Position de ${balise.name || 'ce véhicule'}`" />
            <span v-else-if="coordinates" class="vehicle-map-preview__pin" aria-label="Position du véhicule"></span>

            <div v-if="!coordinates" class="vehicle-map-preview__unavailable">
                Position indisponible
            </div>
        </div>

        <div class="card-footer bg-white py-3 text-center">
            <RouterLink v-if="balise.id" :to="'/home/' + balise.id">Voir sur la carte</RouterLink>
        </div>
    </div>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer } from '@vue-leaflet/vue-leaflet';

export default {
    name: 'VehicleMapIcon',
    components: { LMap, LTileLayer },
    props: {
        balise: { type: Object, required: true }
    },
    data() {
        return {
            tileLayerUrl: 'https://api.maptiler.com/maps/bright-v2/{z}/{x}/{y}.png?key=EevE8zHrA8OKNsj637Ms',
            mapOptions: {
                zoomControl: false,
                attributionControl: false,
                dragging: false,
                scrollWheelZoom: false,
                doubleClickZoom: false,
                touchZoom: false,
                boxZoom: false,
                keyboard: false
            }
        };
    },
    computed: {
        coordinates() {
            const latitude = this.balise.lastLatitude;
            const longitude = this.balise.lastLongitude;

            if (latitude == null || latitude === '' || longitude == null || longitude === '') {
                return null;
            }

            const lat = Number(latitude);
            const lng = Number(longitude);

            if (!Number.isFinite(lat) || !Number.isFinite(lng) ||
                lat < -90 || lat > 90 || lng < -180 || lng > 180) {
                return null;
            }

            return [lat, lng];
        }
    }
};
</script>

<style scoped>
.vehicle-map-preview {
    position: relative;
    height: 185px;
    overflow: hidden;
    background: #eef3f8;
}

.vehicle-map-preview__leaflet {
    width: 100%;
    height: 100%;
    z-index: 0;
}

.vehicle-map-preview__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 500;
    max-width: 110px;
    max-height: 100px;
    object-fit: contain;
    pointer-events: none;
    transform: translate(-50%, -50%);
    filter: drop-shadow(0 8px 9px rgba(24, 45, 68, 0.2));
}

.vehicle-map-preview__pin {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 500;
    width: 20px;
    height: 20px;
    border: 4px solid #fff;
    border-radius: 50%;
    background: #2866b8;
    box-shadow: 0 3px 12px rgba(24, 45, 68, 0.3);
    pointer-events: none;
    transform: translate(-50%, -50%);
}

.vehicle-map-preview__unavailable {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #7d899a;
    font-size: 0.85rem;
}

</style>
